import React, { useCallback } from 'react';
import shave from 'shave';

interface TruncateTextProps {
    text: string;
    maxHeight: number;
}

type spanRefType = HTMLSpanElement & (string | NodeList);

export default function TruncateText({ text, maxHeight }: TruncateTextProps) {
    const callbackRef = useCallback(
        (element: spanRefType) => {
            // HACK: Edge cases exist where it is possible for the height
            // of the text container to change. This causes issues when shave runs prior
            // to the height being at its desired value.
            // This defers shave running to the next browser repaint.
            window.requestAnimationFrame(() => shave(element, maxHeight));
        },
        [maxHeight]
    );

    return <span ref={callbackRef}>{text}</span>;
}
